import { DashboardLayout } from '@/app/layout/DashboardLayout';
import { GuardianLayout } from '@/app/layout/GuardianLayout';
import { isGuardianPortalOnly, useAuthStore } from '@/store';

/**
 * Staff see {@link DashboardLayout} (sidebar + hubs); guardian-only users see
 * {@link GuardianLayout} (top bar only).
 */
export function WorkspaceLayout() {
  const user = useAuthStore((s) => s.user);

  if (isGuardianPortalOnly(user)) {
    return <GuardianLayout />;
  }

  return <DashboardLayout />;
}
